export default __webpack_public_path__ + "static/media/02.0ac72217.png";